<template>
  <ms-dynamic-popup
    title="Tham số in chứng từ"
    classTitle="report-param-title"
    :width="600"
    dockPosition="right"
    classDetail="report-param-body"
    @beforeOpen="beforeOpen($event, close)"
    @beforeClose="beforeClose"
    @shortkeyAction="shortkeyAction"
    name="ReportParamAccountVoucher"
  >
    <template v-slot:icon>
      <a
        class="button icon24 ic-question mr-2"
        v-tooltip="'Trợ giúp'"
        shortkey-target="Help"
        target="_blank"
        :href="linkHelp($ms.constant.Help.VoucherReport)"
      ></a>
    </template>
    <template #content>
      <div class="pd-popup h-full">
        <div class="mt-1 mr-2 mt6 radio-popup">
          <div class="radio">
            <ms-radio
              label="Chỉ hiển thị dòng định khoản đơn"
              name="rdname"
              class="mr-2"
              :keyValue="0"
              v-model="model.displayAccountNumberType"
              @msChange="changeSelectAppear"
            />
          </div>
          <div class="radio">
            <ms-radio
              label="Chỉ hiển thị dòng định khoản gốc"
              name="rdname"
              class="mr-2"
              :keyValue="1"
              v-model="model.displayAccountNumberType"
              @msChange="changeSelectAppear"
            />
          </div>
          <div class="radio">
            <ms-radio
              label="Bao gồm dòng định khoản gốc và định khoản đơn"
              name="rdname"
              class="mr-2"
              :keyValue="2"
              v-model="model.displayAccountNumberType"
              @msChange="changeSelectAppear"
            />
          </div>

          <!-- 2 checkbox con ở dưới Radio thứ 3 -->
          <div class="both-single-org checkbox-radio" v-if="model.displayAccountNumberType === 2">
            <ms-checkbox
              label="Sắp xếp định khoản đơn ngay dưới định khoản gốc"
              v-model="model.isAlternateSort"
              class="checkbox-child"
            />
            <ms-checkbox
              label="Cộng số tiền các dòng định khoản đơn"
              v-model="model.isAddAmountSingle"
              class="checkbox-child"
            />
          </div>
        </div>

        <div class="mt-1 mr-2 mt6 checkbox">
          <ms-checkbox label="Cộng gộp các bút toán giống nhau" v-model="model.isSummarySameInfo" />
        </div>
      </div>
    </template>

    <template #footer="{close}">
      <div class="h-100 account-voucher flex-between flex-row-reverse flex1">
        <ms-button text="Đồng ý" @click="commandClick($ms.constant.Command.Ok)" />
        <ms-button
          ref="btnCancel"
          text="Hủy"
          v-tooltip="'Hủy (Ctrl + H)'"
          shortkey-target="Cancel"
          type="outline-button"
          has-border
          class="mr-2"
          @click="close"
        />
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import {defineComponent, getCurrentInstance} from 'vue';
import baseVoucherReportParam from '@/views/base/baseVoucherReportParam';
import MsCheckbox from '@/components/checkbox/MsCheckbox.vue';
import {ModuleAccountingObject} from '@/stores/moduleConst';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import popupUtil from '@/commons/popupUtil';
import _ from 'lodash';

export default defineComponent({
  components: {MsCheckbox},
  extends: baseVoucherReportParam,

  setup() {
    const {proxy} = getCurrentInstance();
    const module = ModuleAccountingObject;

    function beforeOpen(e) {
      proxy.super('beforeOpen', baseVoucherReportParam, e);
      proxy.model.displayAccountNumberType = 2;
      proxy.model.isAlternateSort = false;
      proxy.model.isAddAmountSingle = false;
      proxy.model.isSummarySameInfo = false;
    }

    function commandClick(command) {
      const me = proxy;
      switch (command) {
        case proxy.$ms.constant.Command.Ok:
          if (proxy.offlineReady) {
            // Nếu in khi mất mạng
            let dataModel = _.cloneDeep(proxy._report.dataModel);
            if (dataModel?.Detail?.length > 0) {
              dataModel.Detail = dataModel.Detail.filter(
                x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
              );
            }
            popupUtil.show('ReportOfflineDesigner', {
              dataVoucher: proxy._report.dataVoucher,
              dataModel: dataModel,
              param: proxy.model,
              report: proxy._report.report,
            });
            proxy.hide();
          } else {
            proxy.super('commandClick', baseReportParam, command);
          }
          break;
        default:
          proxy.super('commandClick', baseReportParam, command);
          break;
      }
    }

    /**
     * Chuyển 2 checkbox con thành false nếu bỏ tick chọn radio thứ 3
     * vqphong - 03/11/2022
     */
    const changeSelectAppear = () => {
      if (proxy.model.displayAccountNumberType !== 3) {
        proxy.model.isAlternateSort = false;
        proxy.model.isAddAmountSingle = false;
      }
    };

    return {
      proxy,
      changeSelectAppear,
      beforeOpen,
      commandClick,
    };
  },

  computed: {
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
  },
});
</script>

<style lang="scss" scoped>
:deep {
  .ms-checkbox--text {
    padding-left: 2px;
  }
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.radio-popup {
  margin-left: 5px;
  margin-top: 15px !important;

  .checkbox-radio {
    padding-left: 60px;

    .checkbox-child {
      margin-bottom: 11px;
    }
  }

  .radio {
    margin-bottom: 13px;
  }
}

.checkbox {
  margin-left: 1px !important;
}

.flex-between.account-voucher {
  justify-content: right;
}
</style>
